// src/api/axios.js
import axios from "axios";

const api = axios.create({
baseURL: "https://js.pro.et", // use HTTPS now

 //baseURL: "http://localhost:5000", // change to your backend port
});
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);
export default api;
